import baseTheme, { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries, { breakpointKeys } from "@insite/mobius/utilities/breakpointMediaQueries";
import styled, { css } from "styled-components";

export const rem = (value: number) => `${value / 16}rem`;
export const calcWidth = (width: number, gutter: number) => width - gutter * 2;
export const hideMobile = ({ theme }: { theme: BaseTheme }) =>
    breakpointMediaQueries(theme, [
        css`
            display: none;
        `,
        css`
            display: none;
        `,
        null,
        null,
        null,
    ]);
export const reverseMobile = ({ theme }: { theme: BaseTheme }) =>
    breakpointMediaQueries(theme, [
        css`
            flex-direction: row-reverse;
            justify-content: flex-start;
        `,
        css`
            flex-direction: row-reverse;
            justify-content: flex-start;
        `,
        null,
        null,
        null,
    ]);
export const offscreenSpan = styled.span`
    margin: -1px;
    padding: 0;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
    clip: rect(0, 0, 0, 0);
    position: absolute;
`;

export const breakpointWidth =
    (min: typeof breakpointKeys[number], isMaxWidth = false) =>
    ({ theme }: { theme: BaseTheme }) => {
        const values = theme.breakpoints.values ?? baseTheme.breakpoints.values;
        const minIndex = breakpointKeys.findIndex(key => key === min);

        return isMaxWidth ? `${values[minIndex] - 1}px` : `${values[minIndex]}px`;
    };

export const removeBorder = css`
    border: none;
    border-radius: 0;
`;

export const tint = (color: string, amount: number) => {
    const R = parseInt(color.substring(1, 3), 16);
    const G = parseInt(color.substring(3, 5), 16);
    const B = parseInt(color.substring(5, 7), 16);

    const getSingle = (value: number) => {
        const single = Math.round(value * (1 - amount) + 255 * amount);
        const output = single.toString(16);
        return output.length === 1 ? `0${output}` : output;
    };

    return `#${getSingle(R)}${getSingle(G)}${getSingle(B)}`;
};

export const transparentize = (color: string, amount: number) => {
    const alpha = Math.round(255 * amount);
    const output = alpha.toString(16);
    return `${color}${output}`;
};

export const topZindex = 1000;
